<!-- eslint-disable max-len -->
<template>
  <div id="third-party-container">

    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <h4 class="title-tab-experience-manager">Third Party Connection</h4>
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="openModal">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-form
            inline
            @keypress.13.prevent="filter(filter_data)">
            <j-select
              v-model="select_type"
              :options="options_search"
              :error-required="false"
              placeholder="Filter By"
              class="m__r--5"/>
            <b-form-input
              ref="filterInput"
              v-model="filter_data"
              placeholder="Search"
              style="width: 250px; height: 35px"/>
          </b-form>
        </b-form>
      </div>
    </div>

    <div class="studio-page-content">
      <v-server-table
        v-show="load_first"
        ref="thirdPartyTable"
        :columns="columns"
        :options="table_options"
        class="jTable"
        @loading="loading"
        @loaded="loaded"
        @row-click="openDetail">

        <div
          slot="created_at"
          slot-scope="props">
          {{ convertDateTime(props.row.created_at) }}
        </div>

        <div
          slot="updated_at"
          slot-scope="props">
          {{ convertDateTime(props.row.updated_at) }}
        </div>
      </v-server-table>
      <jLoadingTable v-if="!load_first"/>

    </div>

    <b-popover
      ref="searchFormModal"
      :show.sync="popoverSearchShow"
      container="third-party-container"
      target="targetSearch"
      triggers="click"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>

    <b-modal
      ref="modalForm"
      class="mod-form modal-form-ui"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <j-third-party-form
        v-if="isOpen"
        :list-plugin="listPlugin"
        :detail-connection="detailConnection"
        @close-modal="closeModal"/>
    </b-modal>

  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import { mapActions, mapState } from 'vuex';
import jwtDecode from 'jwt-decode';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jApiThirdParty from '@/services/jApiThirdParty';
import jThirdPartyForm from './jThirdPartyForm';

export default {
  components: {
    jLoadingTable,
    jThirdPartyForm,
  },
  data() {
    return {
      listEnv: [],
      jsonData: '',
      typeMode: '',
      darkMode: false,
      tabSelected: 'single',
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),

      // Single Form UI
      popoverSearchShow: false,
      isOpen: false,
      load_first: false,
      filter_data: '',
      select_type: 'connection_name',
      options_search: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'connection_name',
        },
      ],
      columns: ['id', 'connection_name', 'plugin_name', 'environment', 'created_at', 'updated_at'],
      table_options: {
        headings: {
          id: 'ID',
          connection_name: 'CONNECTION NAME',
          plugin_name: 'THIRD PARTY',
          environment: 'ENVIRONTMENT',
          created_at: 'CREATED DATE',
          updated_at: 'UPDATED DATE',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: ['id', 'connection_name', 'plugin_name', 'environment', 'created_at', 'updated_at'],
        debounce: 1000,
        filterable: true,
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],

        requestAdapter(data) {
          let sortData = {};
          switch (data.orderBy) {
            case 'connection_name':
              sortData = { connection_name: data.ascending ? 1 : -1 };
              break;
            case 'id':
              sortData = { id: data.ascending ? 1 : -1 };
              break;
            case 'environment':
              sortData = { environment: data.ascending ? 1 : -1 };
              break;
            case 'plugin_name':
              sortData = { plugin_name: data.ascending ? 1 : -1 };
              break;
            case 'created_at':
              sortData = { created_at: data.ascending ? 1 : -1 };
              break;
            case 'updated_at':
              sortData = { updated_at: data.ascending ? 1 : -1 };
              break;
            default:
              sortData = { created_at: -1 };
          }
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              sort: sortData,
            },
          };
        },
        requestFunction(data) {
          const list = jApiThirdParty.getListThirdPartyConnection(data.pagination);
          return list.catch((e) => {
            this.$store.commit('jStoreNotificationScreen/toggleProblem', e.message);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreThirdParty', ['list_plugin']),

    listPlugin() {
      return this.list_plugin.map(val => ({
        plugin_name: val.name,
        environment: val.environment,
        logo: val.logo,
        config_scheme: val.config,
      }));
    },
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.thirdPartyTable.setFilter('');
      }
    },
  },
  created() {
    this.getThirdPartyPlugin();
  },
  mounted() {
    this.$refs.filterInput.focus();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreThirdParty', ['getThirdPartyPlugin', 'detailThirdPartyConnection', 'deleteThirdPartyConnection']),

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },

    loading(data) {
      const { pagination } = data;
      const dataFilter = {

      };
      if (this.select_type && this.filter_data) {
        dataFilter[this.select_type] = this.filter_data;
      }
      // pagination.query_type = this.select_type;
      pagination.filter = JSON.stringify(dataFilter);
      // pagination.sort = JSON.stringify({ updated_at: -1 });
      if (this.load_first) {
        this.showLoading();
      }
    },
    loaded() {
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },
    filter(val) {
      this.$refs.thirdPartyTable.setFilter(val);
      this.popoverSearchShow = false;
    },

    async openDetail({ row }) {
      const res = await this.detailThirdPartyConnection({ id: row.id });
      if (!res.error) {
        this.detailConnection = res.data;

        this.isOpen = true;
        this.$refs.modalForm.show();
      }
    },
    openModal() {
      this.detailConnection = null;
      this.isOpen = true;
      this.$refs.modalForm.show();
    },
    closeModal() {
      this.isOpen = false;
      this.$refs.modalForm.hide();

      this.$refs.thirdPartyTable.refresh();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/third-party/jThirdPartyList.vue